<template>
  <div
    class="cockpit-dialog fixed"
    :style="{ width, height, top, left, right, zIndex: '999' }"
    v-cockpitDrag="!disabledDrag"
  >
    <div class="h-full dialog-container" :style="{ backgroundColor: bgColor }">
      <div class="cockpit-dialog-header">
        <div class="w-full">
          <CardTitle :title="title" v-if="title" :cardType="cardType"></CardTitle>
        </div>
        <div
          class="cockpit-dialog__close text-white w-36px h-36px iconfont icon-line-close text-center leading-36px ml-10px cursor-pointer absolute top-28px right-20px"
          @click="close"
        ></div>
      </div>
      <div class="w-full h-[calc(100%-62px)] mt-10px">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import CardTitle from './CardTitle'

export default {
  name: 'CockpitDialog',
  components: { CardTitle },
  props: {
    disabledDrag: {
      type: Boolean,
      defalut: false,
    },
    title: {
      type: String,
      defalut: '',
    },
    width: {
      type: String,
      defalut: '1000px',
    },
    height: {
      type: String,
      defalut: '500px',
    },
    top: {
      type: String,
      defalut: '145px',
    },
    left: {
      type: String,
      defalut: '145px',
    },
    right: {
      type: String,
      defalut: '145px',
    },
    cardType: {
      type: String,
      defalut: 'default',
    },
    bgColor: {
      type: String,
      defalut: '#0d293000',
    },
  },
  data() {
    return {
      updateKey: null,
    }
  },
  methods: {
    close() {
      this.updateKey = null
      this.$emit('close')
    },
    getMaxZIndex() {
      const dialogList = document.getElementsByClassName('cockpit-dialog')
      const maxZIndexDialog = _.maxBy(dialogList, (item) => {
        return Number(item.style.zIndex)
      })
      return maxZIndexDialog?.style?.zIndex
    },
    setUpdateKey() {
      this.updateKey = new Date().getTime()
    },
  },
  directives: {
    cockpitDrag: {
      bind(el, binding, vnode, oldVnode) {
        if (binding.value) {
          const odiv = el // 获取当前元素
          const dialogHeaderEl = el.querySelector('.cockpit-dialog-header')
          dialogHeaderEl.style.cssText += ';cursor:move;'
          el.onmousedown = () => {
            // 点击时将弹窗置于所有弹窗最顶级
            const maxZIndex = vnode.context.getMaxZIndex()
            el.style.zIndex = maxZIndex ? Number(maxZIndex) + 1 : '999'
          }
          dialogHeaderEl.onmousedown = (e) => {
            if (e.button === 0) {
              // 点击时将弹窗置于所有弹窗最顶级
              const maxZIndex = vnode.context.getMaxZIndex()
              el.style.zIndex = maxZIndex ? Number(maxZIndex) + 1 : '999'
              // 阻止穿透
              e.stopPropagation()
              // 无需触发拖动的元素
              const className = ['el-slider__button', 'icon-close', 'el-input__inner']
              // 算出鼠标相对元素的位置
              if (!_.isEmpty(_.intersection(className, e.target.className.split(' ')))) {
                return
              }
              // 获取点击元素路径列表
              const ePathList = e.path
              // 是否被'height-routerView'包裹
              const isRouterView = _.findIndex(ePathList, (item) => {
                return item.className === 'h-100 height-routerView'
              })
              const sliderWidth = isRouterView === -1 ? 0 : 200
              const sliderHeight = isRouterView === -1 ? 0 : 90
              const disX = e.clientX - odiv.offsetLeft
              const disY = e.clientY - odiv.offsetTop
              let left = ''
              let top = ''
              document.onmousemove = (element) => {
                // 阻止穿透
                element.stopPropagation()
                // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                left = element.clientX - disX
                top = element.clientY - disY
                // 绑定元素位置到positionX和positionY上面
                // 移动当前元素
                if (left < 0) {
                  left = 0
                } else if (
                  left >
                  document.documentElement.clientWidth - odiv.offsetWidth - sliderWidth
                ) {
                  left = document.documentElement.clientWidth - odiv.offsetWidth - sliderWidth
                }
                if (top < 0) {
                  top = 0
                } else if (
                  top >
                  document.documentElement.clientHeight - odiv.offsetHeight - sliderHeight
                ) {
                  top = document.documentElement.clientHeight - odiv.offsetHeight - sliderHeight
                }
                odiv.style.left = `${left}px`
                odiv.style.top = `${top}px`
              }
            }
            document.onmouseup = () => {
              document.onmousemove = null
              document.onmouseup = null
              document.onmouseout = null
            }
          }
        }
      },
      update(el, binding, vnode) {
        if (vnode.context.updateKey) return
        vnode.context.setUpdateKey()
        const maxZIndex = vnode.context.getMaxZIndex()
        el.style.zIndex = maxZIndex ? Number(maxZIndex) + 1 : '999'
      },
    },
  },
}
</script>

<style lang="scss" scoped>

.cockpit-dialog {
  &__close {
    background-color: var(--dialogCloseBg);
    border-radius: 3.47px;
  }

  .dialog-container {
    padding: 20px;
    background-image: var(--dialogBgImg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}

</style>
